import { Link } from "react-router-dom";
import InfiniteLogo from '../assets/images/InfiniteLogo.jpeg';
const NavBar = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary shadow-sm">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <div className="d-flex align-items-center gap-2 p-2 brand-wrapper">
            <img src={InfiniteLogo} alt="Infinite Edu Tech Logo" className="img-fluid navbar-logo rounded-circle"  />
            <div className="brand-text">
              <h1 className="brand-title m-0">Infinite</h1>
              <h3 className="brand-subtitle m-0">Edu Tech</h3>
            </div>
          </div>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarSupportedContent">
          <ul className="navbar-nav mb-2 mb-lg-0">
            <li className="nav-item dropdown mx-2">
              <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                Who Are We
              </span>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/who-are-we/purpose">
                    Our Purpose
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/who-are-we/team">
                    Our Team
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/who-are-we/careers">
                    Careers
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown mx-2">
              <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                What We Do
              </span>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/what-we-do/our-services">
                    Our Services
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/what-we-do/events">
                    Events
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown mx-2">
              <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" >
                Whom We Help
              </span>
              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/who-we-help/students">
                    Students
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/who-we-help/edtechs">
                    EdTechs
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/who-we-help/universities" >
                    Universities
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
          <Link to="/contact" className="btn btn-primary ms-lg-3">
            Contact Us
          </Link>
        </div>
      </div>
    </nav>
  );
};
export default NavBar;